import { render, staticRenderFns } from "./complaints-end.vue?vue&type=template&id=b1a8caae&"
import script from "./complaints-end.vue?vue&type=script&lang=js&"
export * from "./complaints-end.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports